export * from './IconSeismic2D';
